import { render } from "./CollapseBlock.vue?vue&type=template&id=283d1ab4&scoped=true"
import script from "./CollapseBlock.vue?vue&type=script&lang=js"
export * from "./CollapseBlock.vue?vue&type=script&lang=js"

import "./CollapseBlock.vue?vue&type=style&index=0&id=283d1ab4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-283d1ab4"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
